<template>
  <div class="page">
    <Navbar />
    <Banner
      :hasText="true"
      :haSingleImg="true"
      :text="titulos[0]"
      :imagem="require('@/assets/img/contacts/banner.jpg') "
    />
    <v-container>
      <v-col>
        <v-row>
          <form class="fillw" @submit.prevent="onSubmit">
            <vue-recaptcha
              ref="invisibleRecaptcha"
              size="invisible"
              @verify="onVerify"
              @expired="onExpired"
              sitekey="6LdL0fwUAAAAADaAoYvJkbsWjDOJTVfjznX8amnx"
            />
            <v-select
              eager
              v-model="form.assunto"
              :items="selectOption"
              :label="titulos[1]"
              :error="form.error"
              required
            />
            <v-text-field v-model="form.nome" :label="titulos[2]" required />
            <v-text-field type="email" v-model="form.email" :label="titulos[3]" required />
            <v-textarea v-model="form.mensagem" solo name="input-7-4" :label="titulos[4]" />
            <v-btn type="submit" @click="btnFormSubmit" block class="green pa-6" dark>{{titulos[5]}}</v-btn>
          </form>
        </v-row>
      </v-col>
    </v-container>
    <Footer />

    <v-dialog v-model="dialogVisible" width="290">
      <v-card class="d-flex flex-row" :color="dialogColor" width="100%">
        <v-col cols="9" class="d-flex align-center justify-center">
          <div class="white--text body-1">
            {{dialogText}}
          </div>
        </v-col>
        <v-col cols="3" class="d-flex justify-center align-center">
          <v-btn color="white" class="px-0" text @click="dialogVisible = false">{{titulos[6]}}</v-btn>
        </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>



<script>
import Navbar from "@/components/Navbar.vue";
import Banner from "@/components/Banner.vue";
import Footer from "@/components/Footer.vue";
import VueRecaptcha from "vue-recaptcha";
import { getLangValue } from "@/globalFunctions.js";
import _ from "lodash";

export default {
  name: "Contacts",
  components: {
    Navbar,
    Banner,
    "vue-recaptcha": VueRecaptcha,
    Footer
  },
  async mounted() {
    await this.putTitulos();
  },
  data() {
    return {
      titulos: [],
      selectOption: [],
      dialogVisible: false,
      dialogText: "",
      dialogColor: "",
      form: {
        assunto: "",
        nome: "",
        email: "",
        mensagem: "",
        error: false,
        isReady: false
      }
    };
  },
  methods: {
    btnFormSubmit() {
      if (!_.isEmpty(this.form.assunto)) {
        this.form.isReady = true;
      } else {
        this.form.isReady = false;
      }
    },
    onSubmit: async function() {
      this.$refs.invisibleRecaptcha.execute();
    },
    onVerify: async function(response) {
      if (this.form.isReady) {
        var params = {
          Mensagem: this.form.mensagem,
          Assunto: this.form.assunto,
          Nome: this.form.nome,
          Email: this.form.email,
          Response: response
        };

        var result = await this.$store.dispatch("setContactoForm", params);

        if (result) {
          this.dialogVisible = true;
          this.dialogColor = "green";
          this.dialogText = this.titulos[8];
          this.form.error = false;
        } else {
          this.dialogVisible = true;
          this.dialogColor = "red";
          this.dialogText = this.titulos[7];
          this.form.error = true;
        }

        this.form = {
          assunto: "",
          nome: "",
          email: "",
          mensagem: "",
          isReady: false
        };
      } else {
        this.form.error = true;
      }
      console.log("Verify: " + response);
    },
    onExpired: function() {},
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
    putTitulos: async function() {
      var menuContacts = await getLangValue(
        "Menu",
        "Contactos",
        this.$store.getters.language
      );

      var contactoSelect = await getLangValue(
        "Contactos",
        "Select",
        this.$store.getters.language
      );

      var contactoS1 = await getLangValue(
        "Contactos",
        "S1",
        this.$store.getters.language
      );

      var contactoS2 = await getLangValue(
        "Contactos",
        "S2",
        this.$store.getters.language
      );

      var contactoS3 = await getLangValue(
        "Contactos",
        "S3",
        this.$store.getters.language
      );

      var contactoS4 = await getLangValue(
        "Contactos",
        "S4",
        this.$store.getters.language
      );

      var contactoNome = await getLangValue(
        "Contactos",
        "Nome",
        this.$store.getters.language
      );

      var contactoEmail = await getLangValue(
        "Contactos",
        "Email",
        this.$store.getters.language
      );

      var contactoMenssagem = await getLangValue(
        "Contactos",
        "Menssagem",
        this.$store.getters.language
      );

      var contactoEnviar = await getLangValue(
        "Contactos",
        "Enviar",
        this.$store.getters.language
      );

      var contactoFechar = await getLangValue(
        "Contactos",
        "Fechar",
        this.$store.getters.language
      );

      var erroEnviar = await getLangValue(
        "Erros",
        "Enviar",
        this.$store.getters.language
      );

      var sucessoEnviar = await getLangValue(
        "Sucessos",
        "Enviar",
        this.$store.getters.language
      );

      //select
      this.selectOption.push(contactoS1);
      this.selectOption.push(contactoS2);
      this.selectOption.push(contactoS3);
      this.selectOption.push(contactoS4);

      this.titulos.push(menuContacts);
      this.titulos.push(contactoSelect);
      this.titulos.push(contactoNome);
      this.titulos.push(contactoEmail);
      this.titulos.push(contactoMenssagem);
      this.titulos.push(contactoEnviar);
      this.titulos.push(contactoFechar);
      this.titulos.push(erroEnviar);
      this.titulos.push(sucessoEnviar);
    }
  }
};
</script>